import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromAccountStore from '@appStore/account';
import { SxCookieService } from '@services';
import { CookieAttributes } from 'es-cookie/src/CookieAttributes';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthorizedGuard  {
  constructor(
    private store: Store<fromAccountStore.State>,
    private sxCookieService: SxCookieService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(fromAccountStore.getIsAuthorized).pipe(
      map(x => {
        if (x) {
          return true;
        } else {
          let clientId = '';
          let stateUrl = state.url;
          if (stateUrl) {
            let parts = stateUrl.split('?clientId=');
            if (parts.length > 1) {
              this.setSegmentCookie(parts[1]);
              stateUrl = stateUrl.replace('?clientId=' + parts[1], '');
            }
          }
          this.setDeeplinkCookie(stateUrl);

          //console.log(this.router.url);
          this.router.navigate(['/login']);
          return false;
        }
      })
    );
  }

  private setDeeplinkCookie(deeplink: string) {
    let expiration = new Date();
    expiration.setMinutes(new Date().getMinutes() + 5);
    this.sxCookieService.setCookie('SX_DEEPLINK', deeplink, { expires: expiration } as CookieAttributes);
  }

  private setSegmentCookie(segment: string) {
    let expiration = new Date();
    expiration.setMinutes(new Date().getMinutes() + 5);
    this.sxCookieService.setCookie('SX_SEGMENT', segment, { expires: expiration } as CookieAttributes);
  }
}
